import axios from "axios";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import * as actions from "../reducers/pay";

function loadListAPI() {
  return axios.get(`/api/app/easy-card/my`);
}

function* loadList({ payload }) {
  console.log("payload: ============================== ");
  console.log("loadList payload");
  yield put({
    type: actions.LOADING,
    payload: true,
  });

  try {
    const response = yield call(loadListAPI);
    console.log("response: ", response);
    console.log("response.data.data: ", response.data.data);

    yield put({
      type: actions.LOAD_LIST_SUCCESS,
      payload: response.data.data.easyCardList,
    });
  } catch (error) {
    console.log("error: ", error);
  }

  yield put({
    type: actions.LOADING,
    payload: false,
  });
}

function loadCheckTermsAPI() {
  return axios.post(`/api/app/easy-card/check-terms`);
}

function* loadCheckTerms() {
  console.log("payload: ============================== ");
  console.log("loadCheckTerms payload");
  yield put({
    type: actions.LOADING,
    payload: true,
  });

  try {
    const response = yield call(loadCheckTermsAPI);
    console.log("response: ", response);
    console.log("response.data.data: ", response.data.data);

    yield put({
      type: actions.LOAD_CHECK_TERMS_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    console.log("error: ", error);
  }

  yield put({
    type: actions.LOADING,
    payload: false,
  });
}

function* watchLoadPayList() {
  yield takeEvery(actions.LOAD_PAY_LIST, loadList);
}

function* watchLoadCheckTerms() {
  yield takeEvery(actions.LOAD_CHECK_TERMS, loadCheckTerms);
}

export default function* paySaga() {
  yield all([fork(watchLoadPayList), fork(watchLoadCheckTerms)]);
}
